import Diamond from '../src/Diamond/index.tsx';
export default Diamond;
